<template>
	<LayoutForm>
		<h1 slot="header">Edit Member</h1>
		<MemberFormStep1 type="edit"></MemberFormStep1>
	</LayoutForm>
</template>

<script>
	import LayoutForm from '../Layout/LayoutForm';
	import FormStepNav from '../Form/FormStepNav';
	import MultiStepForm from '../Form/MultiStepForm';
	import MemberFormStep1 from './MemberForm/MemberFormStep1';
    import API from '../../api';
    import {v4 as uuidv4} from 'uuid';

	export default {
		name: 'MemberEditForm',
		mixins: [MultiStepForm],
		components: {
			MemberFormStep1,
			FormStepNav,
			LayoutForm
		},
        methods: {
            fetchResource(id) {
                return API.getMember(id);
            },
            sanitizeResource(member) {
                console.log("Member: ", member);
                console.log("Form data: ", this.formData);
                if(member.hq) {
                    if(member.hq.country) {
                        member.hqCountry = member.hq.country.id;
                        member.region = member.hq.country.region_id;
                    }

                    if(member.hq.location) {
                        member.hqLocation = member.hq.location;
                    }

                    if(member.hq.address_line_1) {
                        member.hqAddressLine1 = member.hq.address_line_1;
                    }

                    if(member.hq.address_line_2) {
                        member.hqAddressLine2 = member.hq.address_line_2;
                    }

                    if(member.hq.address_line_3) {
                        member.hqAddressLine3 = member.hq.address_line_3;
                    }

                    if(member.hq.phone) {
                        member.hqPhone = member.hq.phone;
                    }
                }

                if (member.logo) {
                    this.$store.commit('selectCache/addAttachment', member.logo);
                }

                let offices = [];
                if(member.otherOffices && Array.isArray(member.otherOffices)) {
                    member.otherOffices.forEach(office => {
                        if(office.country && office.location) {
                            let officeObj = {
                                country: office.country.id,
                                location: office.location,
                                id: office.id,
                                uuid: uuidv4(),
                            }

                            if(office.address_line_1) {
                                officeObj.address_line_1 = office.address_line_1;
                            }

                            if(office.address_line_2) {
                                officeObj.address_line_2 = office.address_line_2;
                            }

                            if(office.address_line_3) {
                                officeObj.address_line_3 = office.address_line_3;
                            }

                            if(office.phone) {
                                officeObj.phone = office.phone;
                            }

                            offices.push(officeObj);
                        }
                    })
                }
                member.offices = offices;

                member.logoUrl = `/images/logo/${member.id}`;

                return member;
            }
        },
		data() {
			return {
                totalSteps: 1,
				routeBase: `/members/${ this.id }/edit`,
			}
		}
	}
</script>
